import { render, staticRenderFns } from "./newsListComponent.vue?vue&type=template&id=828e182a&"
import script from "./newsListComponent.vue?vue&type=script&lang=ts&"
export * from "./newsListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports